import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { env } from '@/lib/env';
import { mockCaptures } from '@/lib/mockData';
import { GalleryWall } from '@/components/gallery/GalleryWall';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function GalleryRoute() {
  const { data } = useQuery({
    queryKey: ['gallery'],
    queryFn: () => (env.mock ? Promise.resolve(mockCaptures()) : api.listCaptures()),
    refetchInterval: 300_000,
  });

  return (
    <div className="min-h-screen px-6 py-10 max-w-7xl mx-auto">
      <Link
        to="/wall"
        className="inline-flex items-center gap-1.5 text-body-sm text-inkFaded mb-6 hover:text-tomato"
      >
        <ArrowLeft size={14} /> back to the wall
      </Link>
      <GalleryWall captures={data ?? []} />
    </div>
  );
}
